module.exports = __webpack_public_path__ + "img/komdigi.0a928070.png";